import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from '@mui/material';
import { Container } from '@mui/system';
import { useParams } from 'react-router';
import PageLoader from '../../Components/Spinner/PageLoader';
import { getStatusLabel } from '../../Utils/Label/status-label';
import { useSingleAgencyInfo } from '../../rest/useAgencyInfoUpdateApplication';
import ModalsWrapper from '../../Components/Modals/ModalsWrapper';
import PdfAndImageView from '../../Components/pdfAndImageView/PdfAndImageView';
import { useState } from 'react';
import { CommonTypoGraphy } from '../../Components/pdfAndImageView/CommonTypoGraphy';
import CommonDetailItem, {
  formatDate,
  formatValue,
} from '../../Components/CommonDetailItem/CommonDetailItem';

const SingleAgencyUpdateInfo = () => {
  const { id } = useParams();
  const { singleAgencyInfo: application, isLoading } = useSingleAgencyInfo(
    Number(id)
  );
  const [open, setOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null | undefined>('');

  return (
    <>
      {!isLoading ? (
        <Container sx={{ pt: 5 }}>
          <Card>
            <CardHeader title='Application information' />
            <CardContent>
              {application ? (
                <Grid container pt={2} spacing={2}>
                  {application.agency_info_created_at && (
                    <CommonDetailItem
                      label='Application Date'
                      value={formatDate(application.agency_info_created_at)}
                      md={6}
                    />
                  )}
                  {application.status && (
                    <CommonDetailItem
                      label='Status'
                      value={getStatusLabel(application.status)}
                      md={6}
                    />
                  )}
                  {application.agency_name && (
                    <CommonDetailItem
                      label='New Agency name'
                      value={formatValue(application.agency_name)}
                      md={6}
                    />
                  )}
                  {application.ownership_status && (
                    <CommonDetailItem
                      label='Ownership status'
                      value={formatValue(application.ownership_status)}
                      md={6}
                    />
                  )}
                  {application.agency_email && (
                    <CommonDetailItem
                      label='Agency email'
                      value={formatValue(application.agency_email)}
                      md={6}
                    />
                  )}
                  {application.credential_email && (
                    <CommonDetailItem
                      label='New Credential email'
                      value={formatValue(application.credential_email)}
                      md={6}
                    />
                  )}
                  {application.user_member_representative_name && (
                    <CommonDetailItem
                      label='Representative name'
                      value={formatValue(
                        application.user_member_representative_name
                      )}
                      md={6}
                    />
                  )}
                  {application.user_member_representative_photo && (
                    <CommonDetailItem
                      label='Owner photo'
                      value={
                        <CommonTypoGraphy
                          name='View representative photo'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(
                              application.user_member_representative_photo
                            );
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.user_member_representative_designation && (
                    <CommonDetailItem
                      label='Designation'
                      value={formatValue(
                        application.user_member_representative_designation
                      )}
                      md={6}
                    />
                  )}
                  {application.phone && (
                    <CommonDetailItem
                      label='Mobile number'
                      value={formatValue(application.phone)}
                      md={6}
                    />
                  )}
                  {application.cellphone && (
                    <CommonDetailItem
                      label='Telephone number'
                      value={formatValue(application.cellphone)}
                      md={6}
                    />
                  )}
                  {application.member_company_website && (
                    <CommonDetailItem
                      label='Website'
                      value={
                        <a
                          href={
                            application.member_company_website.startsWith('http')
                              ? application.member_company_website
                              : `https://${application.member_company_website}`
                          }
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {application.member_company_website}
                        </a>
                      }
                      md={6}
                    />
                  )}
                  {application.civil_aviation_english_copy && (
                    <CommonDetailItem
                      label='Civil Aviation English copy'
                      value={
                        <CommonTypoGraphy
                          name='View document'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(
                              application.civil_aviation_english_copy
                            );
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.trade_license && (
                    <CommonDetailItem
                      label='Trade license'
                      value={
                        <CommonTypoGraphy
                          name='View document'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(application.trade_license);
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.forwarding_letter && (
                    <CommonDetailItem
                      label='Forwarding letter'
                      value={
                        <CommonTypoGraphy
                          name='View document'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(application.forwarding_letter);
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.partnership_deed && (
                    <CommonDetailItem
                      label='Partnership deed'
                      value={
                        <CommonTypoGraphy
                          name='View document'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(application.partnership_deed);
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.incorporation_certificate && (
                    <CommonDetailItem
                      label='Incorporation certificate'
                      value={
                        <CommonTypoGraphy
                          name='View document'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(
                              application.incorporation_certificate
                            );
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.moa && (
                    <CommonDetailItem
                      label='MoA'
                      value={
                        <CommonTypoGraphy
                          name='View document'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(application.moa);
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.form_xii && (
                    <CommonDetailItem
                      label='Form XII'
                      value={
                        <CommonTypoGraphy
                          name='View document'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(application.form_xii);
                          }}
                        />
                      }
                      md={6}
                    />
                  )}
                  {application.note && (
                    <CommonDetailItem
                      label='Note'
                      value={formatValue(application.note)}
                      md={6}
                    />
                  )}
                </Grid>
              ) : (
                <Typography
                  variant='body1'
                  fontWeight='bold'
                  color='text.primary'
                  display='inline'
                  sx={{ pr: 1 }}
                  gutterBottom
                >
                  No Data found
                </Typography>
              )}
            </CardContent>
          </Card>
        </Container>
      ) : (
        <PageLoader />
      )}
      <>
        <ModalsWrapper
          modalData={{ title: 'View document' }}
          setShowModal={setOpen}
          showModal={open}
        >
          <PdfAndImageView file={imageFile} />
        </ModalsWrapper>
      </>
    </>
  );
};

export default SingleAgencyUpdateInfo;
